<h2>
    Manage Driver Attributes
    <button class="icon--add btn--default" type="button" (click)="addRestriction()" *ngIf="!isReadOnly && customerNumberId > 0">Add Attribute</button>
</h2>
<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<p-table [value]="driverAttributes">
    <ng-template pTemplate="header">
        <tr>
            <th>Restriction Code</th>
            <th>Description</th>
            <th>Source/Authority</th>
            <th>Attribute Category</th>
            <th>Updated By</th>
            <th class="w--date-short">Updated Date</th>
            <th class="w--date-short">End Date</th>
            <th class="w--icon">Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
        <tr>
            <td>{{ rowData.code }}</td>
            <td>{{ rowData.displayValue }}</td>
            <td>{{ rowData.source }}</td>
            <td>{{ rowData.attributeCategory }}</td>
            <td class="td--hover-show">{{ rowData.updatedBy }}</td>
            <td>{{ rowData.updatedDate | shortDate}}</td>
            <td>{{ rowData.endDate | shortDate }}</td>
            <td>
                <a *ngIf="customerNumberId > 0 && rowData.attributeAccessTypeId == driverAttributeAccessType.Write.id && rowData.endDate == null && !isReadOnly" class="icon--delete" title="Delete Restriction" href="javascript:void(0)" (click)="deleteRestriction(rowData.attributeTypeId)"></a>
                <a *ngIf="customerNumberId > 0 && rowData.attributeAccessTypeId == driverAttributeAccessType.Write.id && rowData.endDate == null && !isReadOnly && rowData.attributeTypeId == 22" class="icon--edit" title="Edit Restriction" href="javascript:void(0)" (click)="editRestriction(rowData.id)"></a>
            </td>
        </tr>
    </ng-template>
</p-table>

<h2>Manage Driver Credential Attributes</h2>
<p-table [value]="credentialAttributes">
    <ng-template pTemplate="header">
        <tr>
            <th>Restriction Code</th>
            <th>Description</th>
            <th>Source/Authority</th>
            <th>Attribute Category</th>
            <th class="w--date-short">End Date</th>
            <th>Updated By</th>
            <th class="w--date-short">Updated Date</th>
            <th class="w--icon">Delete</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
        <tr>
            <td>{{ rowData.code }}</td>
            <td>{{ rowData.displayValue }}</td>
            <td>{{ rowData.source }}</td>
            <td>{{ rowData.attributeCategory }}</td>
            <td>{{ rowData.endDate | shortDate }}</td>
            <td class="td--hover-show">{{ rowData.updatedBy }}</td>
            <td>{{ rowData.updatedDate | shortDate}}</td>
            <td class="text-center">
                <a *ngIf="customerNumberId > 0 && rowData.attributeAccessTypeId == driverAttributeAccessType.Write.id && rowData.endDate == null && !isReadOnly" class="icon--delete" title="Delete Restriction" href="javascript:void(0)" (click)="deleteDriverCredentialAttribute(rowData.id)"></a>
            </td>
        </tr>
    </ng-template>
</p-table>